<template>
  <div>
    <template v-if="HomeData">
      <!-- 頭 -->
      <nav class="navbar" v-if="HomeData">
        <div class="container">
          <div class="menu_box">
            <div class="logo_box">
              <img :src="HomeData.SiteLogo" alt="">
              <h1>
                外交部「國際青年大使交流計畫」
                <br>
                線上報名系統
              </h1>
            </div>
            <ul class="menu">
              <li class="">
                <a class="revise" href="" data-bs-toggle="modal" data-bs-target="#revise_box">
                  <p>修改暫存檔 / 報名進度查詢</p>
                </a>
              </li>
              <li class="">
                <router-link to="/">
                  <p>回首頁</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div class="top_btn">
        <a href="javascript:void(0)" @click="toTop()">
          <p>TOP</p>
        </a>
      </div>
      <div class="wrapper youth_ambassadors">
        <div class="plan_box">
          <div class="container" v-if="HomeData && HomeData.Project_Text" v-html="HomeData.Project_Text">
          </div>
        </div>
        <div class="btn_box" v-if="HomeData && HomeData.PDF_Url">
          <div class="container">
            <div class="box">
              <p>本計畫詳細資訊，請查看甄選公告</p>
              <div>
                <a class="detail_btn" :href="HomeData.PDF_Url" target="_blank">
                  甄選公告PDF
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="apply_box">
          <div class="container">
            <div class="text" v-if="HomeData && HomeData.Apply_Text" v-html="HomeData.Apply_Text">
            </div>
            <div class="group" style="text-align: center;">
              <div class="place_box" style="display: flex; justify-content: center;">
                <div class="form-check">
                  <input class="form-check-input" id="IsAgree" name="IsAgree" type="checkbox" v-model="IsAgree">
                  <label class="form-check-label" for="IsAgree">
                    我已詳細閱讀並同意遵守「{{HomeData.Season.Name}}」等相關規定。
                  </label>
                </div>
              </div>
            </div>
            <div class="apply_btn">
              <button class="apply" @click="goApply()">開始報名</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade reserve_send_btn_box revise_box" id="revise_box" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h2><img src="img/icon_6.svg" alt="">修改報名資訊</h2>
              <div class="box">
                <div class="group">
                  <label for="Name" class="form-label"><span>*</span>姓名</label>
                  <input type="text" class="form-control" id="Name" placeholder="請輸入姓名" v-model="Name">
                </div>
                <div class="group">
                  <label for="IDNumber" class="form-label"><span>*</span>身分證字號</label>
                  <input type="text" class="form-control" id="IDNumber" placeholder="請輸入身分證字號" v-model="IDNumber">
                </div>
                <div class="group">
                  <label for="Email" class="form-label"><span>*</span>電子郵件</label>
                  <input type="text" class="form-control" id="Email" placeholder="請輸入電子郵件" v-model="Email">
                </div>
              </div>
              <div class="btn_box">
                <button type="button" class="" @click="applyCheck()">送出</button>
                <button type="button" class="" data-bs-dismiss="modal">取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterBlock />
    </template>
  </div>
</template>
<script>
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Home",
  i18n,
  components: {
    FooterBlock,
    Slick,
  },
  data() {
    return {
      HomeData: null,
      Name: '',
      IDNumber: '',
      Email: '',
      local: "zh_tw",
      IsAgree: false,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Home",
        {
          params: {
            lang: $cookies.get("gya_main_lang")
          },
        }
      )
      .then((response) => {
        if (!response.data.Season) {
          this.$router.push({
            name: "Close"
          });
        }
        this.HomeData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gya_main_lang")) {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = $cookies.get("gya_main_lang");
    } else {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = "zh_tw";
    }
    // 回頂端
    $("html body").scroll(function () {
      var N = $("html body").scrollTop();
      if (N > 400) {
        $('.top_btn').css('display', 'block');
      }
      else {
        $('.top_btn').css('display', 'none');
      };
    });
  },
  updated: function () {
  },
  methods: {
    toTop() {
      $('html,body').animate({ scrollTop: 0 }, 1000);
    },
    goApply() {
      if (!this.IsAgree) {
        Swal.fire({
          title: "提醒",
          text: "請先勾選同意相關規定後，再開始報名。",
          icon: "warning",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      this.$router.push({ name: 'Apply' });
    },
    applyCheck() {
      let that = this;
      if (!that.Name || !that.IDNumber || !that.Email) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入姓名、身份證字號及電子郵件",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return false;
      }
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/ApplyCheck",
        type: "post",
        data: {
          Name: that.Name,
          IDNumber: that.IDNumber,
          Email: that.Email,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            $('#revise_box').modal('hide');
            that.$router.push({
              name: "Apply",
              params: {
                EditToken: res.EditToken
              }
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    }
  },
};
</script>
